import { usePendingOrders } from '@/modules/orders/hooks/use-pending-orders';
import { LordIcon } from '@/shared/components/ui/lord-icon';

interface OrdersTabItemProps {
  icon: string;
  title: string;
  onClick: () => void;
}

export function OrdersTabItem({ icon, title, onClick }: OrdersTabItemProps) {
  const { hasPendingOrders } = usePendingOrders();

  return (
    <button className="flex flex-col items-center justify-center space-y-2.5 h-16 py-2" onClick={onClick}>
      <div className="relative">
        <LordIcon 
          src={icon} 
          trigger="click" 
          size={26}
        />
        {hasPendingOrders && (
          <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-primary rounded-full" />
        )}
      </div>
      <span className="text-xs text-night">{title}</span>
    </button>
  );
}
